import { OrganizationInvitationStatus } from '@/types/organization'

export enum OrganizationRole {
  User = 'user',
  PortfolioManager = 'portfolio_manager',
}

export type OrganizationMetadata = {
  id: string
  role: OrganizationRole
}

export const organizationRoleLabels: Record<OrganizationRole, string> = {
  [OrganizationRole.User]: 'User',
  [OrganizationRole.PortfolioManager]: 'Portfolio Manager',
}

export const invitationStatusLabels: Record<
  OrganizationInvitationStatus,
  string
> = {
  [OrganizationInvitationStatus.Pending]:
    'Invitation sent · awaiting acceptance',
  [OrganizationInvitationStatus.Accepted]: 'Joined the organization',
  [OrganizationInvitationStatus.Revoked]: 'Invitation withdrawn',
  [OrganizationInvitationStatus.Expired]: 'Invitation expired',
}

export const invitationStatusBadges: Record<
  OrganizationInvitationStatus,
  string
> = {
  [OrganizationInvitationStatus.Pending]: 'bg-warning',
  [OrganizationInvitationStatus.Accepted]: 'bg-success',
  [OrganizationInvitationStatus.Revoked]: 'bg-destructive',
  [OrganizationInvitationStatus.Expired]: 'bg-destructive',
}

export const membersTableColumnClasses: Record<string, string> = {
  identity: 'w-[50%] px-6',
  role: 'w-[25%] px-6',
  status: 'w-[13%] px-6',
  actions: 'w-[12%] px-6',
}

export const invitationsTableColumnClasses: Record<string, string> = {
  identity: 'w-[75%] px-6',
  status: 'w-[13%] px-6',
  actions: 'w-[12%] px-6',
}

export const membersTableHeadClassName =
  'text-muted-foreground text-xs uppercase'

export const getOrganizationRole = (
  publicMetadata: Record<string, unknown> | undefined,
  organizationId: string
): OrganizationRole => {
  const organizations = publicMetadata?.organizations as
    | OrganizationMetadata[]
    | undefined

  const role = organizations?.find((entry) => entry.id === organizationId)
    ?.role as OrganizationRole | undefined

  return role ?? OrganizationRole.User
}
